/**
 * @flow
 * @relayHash d3eb6452ed8f66c43719fc926913381c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type QcQueryVariables = {||};
export type QcQueryResponse = {|
  +qcIntegrationEnabled: boolean,
  +qcAppUrl: string,
  +qcSummary: ?{|
    +openInspectionsCount: number,
    +closedInspectionsLast30Days: number,
    +passRateLast30Days: ?number,
    +openIssuesCount: number,
    +generatedAt: any,
  |},
|};
export type QcQuery = {|
  variables: QcQueryVariables,
  response: QcQueryResponse,
|};
*/


/*
query QcQuery {
  qcIntegrationEnabled
  qcAppUrl
  qcSummary {
    openInspectionsCount
    closedInspectionsLast30Days
    passRateLast30Days
    openIssuesCount
    generatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "qcIntegrationEnabled",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "qcAppUrl",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "qcSummary",
    "storageKey": null,
    "args": null,
    "concreteType": "QcSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "openInspectionsCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "closedInspectionsLast30Days",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "passRateLast30Days",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "openIssuesCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "generatedAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "QcQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "QcQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "QcQuery",
    "id": null,
    "text": "query QcQuery {\n  qcIntegrationEnabled\n  qcAppUrl\n  qcSummary {\n    openInspectionsCount\n    closedInspectionsLast30Days\n    passRateLast30Days\n    openIssuesCount\n    generatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12b4816baeef7afb694eb1110c887cf7';
module.exports = node;
